<template>
  <div>
    <div class=" my-2">
      <div class="d-flex gap flex-wrap align-center bg-light_bluegrey pa-2 rounded">
        <v-avatar size="40" color="primary-dark"><span class="text-h5">{{ initiales_coureur }}</span></v-avatar>
        <div>
          <div class="font-weight-bold text-h6">{{ coureur_name }}</div>
          <div v-if="coureur_parcours">{{ coureur_parcours }}</div>
        </div>
      </div>

      <div class="pa-2">
        <v-row>
          <v-col cols="12" md="9">
            <InscriptionItem v-for="item in commande_inscription.inscriptions" :item="item"
              :all_commande_inscription="commande_inscription" :gia="commande_inscription.gia" :key="item.id"
              :alerte_sms="commande_inscription.alerte_sms" :is_free_commande="commande_inscription.prix == '0'">
            </InscriptionItem>
          </v-col>
          <v-col cols="12" md="3" class="d-flex flex-column gap pt-4">
            <div v-if="commande_inscription.gia && commande_inscription.gia.prix"
              class="d-flex flex-wrap align-center gap rounded border-lighter_bluegrey   bg-lighter_bluegrey pa-2">
              <v-avatar color="green-darken-4" density="compact" class="rounded">
                <v-icon icon="mdi-shield-account"></v-icon>
              </v-avatar>
              <div>A souscrit à la GIA ({{ commande_inscription.gia.prix }}€)</div>
            </div>
            <div v-if="commande_inscription.alerte_sms && commande_inscription.alerte_sms.prix"
              class="d-flex flex-wrap align-center gap rounded border-lighter_bluegrey   bg-lighter_bluegrey pa-2">
              <v-avatar color="primary-dark" density="compact" class="rounded">
                <v-icon icon="mdi-message-processing-outline"></v-icon>
              </v-avatar>
              <div>Alerte SMS ({{ commande_inscription.alerte_sms.prix }}€)</div>
            </div>
            <div v-if="commande_inscription.plan_entrainement && commande_inscription.plan_entrainement.prix"
              class="d-flex flex-wrap align-center gap rounded border-lighter_bluegrey bg-lighter_bluegrey pa-2">
              <v-avatar color="primary-dark" density="compact" class="rounded">
                <v-icon icon="mdi-run"></v-icon>
              </v-avatar>
              <div>{{ plan_entrainement_label }} ({{ commande_inscription.plan_entrainement.prix }}€)</div>
            </div>
            <div>
              <div class="font-weight-bold mb-3">Options/Activités/Articles</div>
              <div v-if="commande_inscription.list_commandes_options.length > 0">
                <div class="rounded  bg-lighter_bluegrey pa-2 mb-2 border-lighter_bluegrey "
                  v-for="(item, index) in commande_inscription.list_commandes_options" :key="index">
                  <b>{{ item.quantite }}x</b> {{ item.nom }}
                  <span v-if="item.size && item.size != ''">(Taille {{ item.size }})</span>
                </div>
              </div>

              <div v-else>Aucune option liée à cette inscription</div>
            </div>
            <div v-if="commande_inscription.donation" class="d-flex flex-wrap align-center gap bordered bg-grey_1">
              <v-avatar color="primary-dark" density="compact" class="rounded-0">
                <v-icon icon="mdi-gift"></v-icon>
              </v-avatar>
              <div>Donation {{ commande_inscription.donation.montant }}€</div>
            </div>
          </v-col>

        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import InscriptionItem from "./Inscription_Item.vue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  components: {
    InscriptionItem,

  },

  data() {
    return {
      commande_inscription: {},
    };
  },
  props: ["item"],
  computed: {
    ...mapStores(useMainStore),
    plan_entrainement_label() {
      return this.mainStore.module.plan_entrainement?.titre || "Plan d'entraînement";
    },
    initiales_coureur() {
      const inscription = this.commande_inscription.inscriptions[0];
      if (!inscription || !inscription.nom || !inscription.prenom) {
        return "NC";
      }
      return inscription.nom[0].toUpperCase() + inscription.prenom[0].toUpperCase();
    },
    coureur_name() {
      const inscription = this.commande_inscription.inscriptions[0];
      if (!inscription || !inscription.nom || !inscription.prenom) {
        return "NC";
      }
      return inscription.nom + " " + inscription.prenom;
    },
    coureur_parcours() {
      if (this.commande_inscription.type == 'pack') {
        return "Pack de courses";
      }
      const inscription = this.commande_inscription.inscriptions[0];
      if (!inscription || !inscription.course) {
        return "Pas de parcours";
      }
      return null;
    },
    valid_options() {
      let options = [];
      for (let option in this.commande_inscription.list_commandes_options) {
        if (this.commande_inscription.list_commandes_options[option].supprime == 0) {
          options.push(this.commande_inscription.list_commandes_options[option]);
        }
      }
      return options;
    },
  },
  methods: {
    get_initiales(inscription) {
      if (inscription == undefined) return "NC";
      if (inscription.nom == undefined || inscription.prenom == undefined) return "NC";
      return inscription.nom[0].toUpperCase() + inscription.prenom[0].toUpperCase();
    },
    get_coureur_name(inscription) {
      if (inscription == undefined) return "";
      return inscription.nom + " " + inscription.prenom;
    },

    get_coureur_club(inscription) {
      if (inscription == undefined) return "";
      if (inscription.champs.club && inscription.champs.club != "") {
        return "Club : " + inscription.champs.club;
      }
      return "";
    },
  },
  created() {
    this.commande_inscription = this.item;
  },
};
</script>

<style lang="scss" scoped></style>